<div class="content with-sidebar">
  <app-folders-sidebar
    [userFolders]="sidebarUserFolders"
    [systemItems]="sidebarSystemItems"
    [productFolders]="sidebarProductFolders"
    [scheduledCount]="amountOfScheduledRules ?? 0"
    [selectedFolderId]="selectedSidebarFolderId"
    [loading]="!rulesLoaded"
    [allRules]="allRulesList"
    [folderRulesMap]="folderRulesMap"
    (folderSelected)="onFolderSelected($event)"
    (folderRenamed)="onFolderRenamed($event)"
    (deleteFolder)="onFolderDeleted($event)"
    (ruleAddedToFolder)="onRuleAddedToFolder($event)"
    (ruleRemovedFromFolder)="onRuleRemovedFromFolder($event)"
    (popupStateChange)="sidebarPopupData = $event"
    (createFolderPopupOpened)="onSidebarCreateFolderOpened()">
  </app-folders-sidebar>
  <div class="sidebar-main-content">
    <div id="sub-header" class="data-rules" [ngClass]="extraEntitiesExpanded ? 'expanded' : ''">
      <nav [ngClass]="!this.metaLoaded || !this.rulesLoaded ? 'not-loaded' : 'loaded'">
        <app-skeleton *ngIf="!this.metaLoaded || !this.rulesLoaded" [style]="'tab-filter-buttons'" [flex]="true"
                      [gap]="12" [count]="5"></app-skeleton>
        <mat-button-toggle-group *ngIf="this.metaLoaded && this.rulesLoaded"
                                 name="selectEntity" aria-label="Select entity buttons"
                                 hideSingleSelectionIndicator="true"
                                 [value]="viewAllSelected ? '' : (selectedEntity ?? '')"
                                 (change)="onEntityToggleChange($event)">
          <section class="core-entities">
            <mat-button-toggle class="view-all"
                               value=""
                               [ngClass]="viewAllSelected ? 'selected' : ''">
              <i class="material-icons-outlined notranslate">checklist</i>
              View All
              <aside>{{ folderViewAllCount }}</aside>
            </mat-button-toggle>
            <!-- TODO: Break out into component to avoid duplication -->
            <mat-button-toggle *ngFor="let entity of coreEntities | keyvalue: shiftLeadButton.bind(this)"
                               [value]="entity.key"
                               [ngClass]="[!viewAllSelected && entity.key === selectedEntity ? 'selected': '',
                                       entitySelectorsMap[entity.key] ? entitySelectorsMap[entity.key] + '-entity' : '']">
              <i [ngClass]="renderIcon(entitySelectorsMap[entity.key])"></i>
              {{ entityMap[entity.key] }}
              <aside>{{ entity.value }}</aside>
            </mat-button-toggle>
            <span *ngIf="!extraEntitiesExpanded" (click)="extraEntitiesExpanded = !extraEntitiesExpanded"
                  class="entity-label-link">View all entities</span>
            <span *ngIf="extraEntitiesExpanded" class="entity-label">Core entities</span>
          </section>
          <aside>
            <section class="file-attachment-entities">
              <mat-button-toggle *ngFor="let entity of fileAttachmentEntities | keyvalue"
                                 [value]="entity.key"
                                 matTooltip="{{entityMap[entity.key]}}"
                                 [ngClass]="[!viewAllSelected && entity.key === selectedEntity ? 'selected': '',
                                       entitySelectorsMap[entity.key] ? entitySelectorsMap[entity.key] + '-entity' : '']">
                <i class="bhi-attach"></i>
                {{ entityMap[entity.key] | TransformFileAttachment }}
                <aside>{{ entity.value }}</aside>
              </mat-button-toggle>
              <span class="entity-label"><i class="bhi-attach"></i> File attachment entities</span>
            </section>
            <section class="additional-entities">
              <ngx-skeleton-loader *ngIf="!this.metaLoaded || !this.rulesLoaded" appearance="circle"
                                   class="sub-header-btn"
                                   count="4" animation="progress"></ngx-skeleton-loader>
              <mat-button-toggle *ngFor="let entity of additionalEntities | keyvalue"
                                 [value]="entity.key"
                                 [ngClass]="[!viewAllSelected && entity.key === selectedEntity ? 'selected': '',
                                         entitySelectorsMap[entity.key] ? entitySelectorsMap[entity.key] + '-entity' : '']">
                <i [ngClass]="renderIcon(entitySelectorsMap[entity.key])"></i>
                {{ entityMap[entity.key] }}
                <aside>{{ entity.value }}</aside>
              </mat-button-toggle>
            </section>
            <section class="custom-object-entities">
              <ngx-skeleton-loader *ngIf="!this.metaLoaded || !this.rulesLoaded" appearance="circle"
                                   class="sub-header-btn"
                                   count="4" animation="progress"></ngx-skeleton-loader>
              <mat-button-toggle *ngFor="let entity of customObjectEntities | keyvalue"
                                 [value]="entity.key"
                                 [ngClass]="[!viewAllSelected && entity.key === selectedEntity ? 'selected': '',
                                       entitySelectorsMap[entity.key] ? entitySelectorsMap[entity.key] + '-entity' : '']">
                <i [ngClass]="renderIcon(entitySelectorsMap[entity.key])"></i>
                {{ entityMap[entity.key] }}
                <aside>{{ entity.value }}</aside>
              </mat-button-toggle>
              <span class="entity-label">Custom object entities</span>
            </section>
          </aside>
        </mat-button-toggle-group>
      </nav>
      <div (click)="extraEntitiesExpanded = !extraEntitiesExpanded" class="plus-more" id="all-entities-dropdown-arrow">
        <i class="bhi-sort-asc"></i></div>
    </div>
    <div class="article-top-sticky gutter-top"></div>
    <div class="article-top-sticky">
      <h2 id="header-grid" class="heading-underline">
        <span class="heading-left">
          <span class="folder-context" *ngIf="!rulesLoaded">
            <app-skeleton [style]="'entity-h2-icon'"></app-skeleton>
            <app-skeleton [style]="'heading-h2-text'"></app-skeleton>
            <app-skeleton [style]="'count-pill'"></app-skeleton>
          </span>
          <span class="folder-context" *ngIf="rulesLoaded">
            <i [ngClass]="selectedFolder['outlinedIcon'] ? 'material-icons-outlined' : 'material-icons'"
               class="notranslate folder-context-icon"
               role="img" [attr.aria-label]="'Folder: ' + selectedFolder.name"
               matTooltip="{{ selectedFolder.name }}" matTooltipPosition="above" [matTooltipShowDelay]="500">
              {{ selectedFolder.icon === 'folder' ? 'folder_open' : selectedFolder.icon }}</i>
            <span class="folder-context-name truncate"
                  [appTooltipOnTruncate]="selectedFolder.name">{{ selectedFolder.name }}</span>
            <span class="folder-context-count" *ngIf="viewAllSelected || !selectedEntity"
                  matTooltip="{{ selectedFolder.count }} Rules across all entities" [matTooltipShowDelay]="500">({{ selectedFolder.count }})</span>
            <span class="entity-filter-count" *ngIf="!viewAllSelected && selectedEntity"
                  [ngClass]="entitySelectorsMap[selectedEntity]">
              <i [ngClass]="renderIcon(entitySelectorsMap[selectedEntity])"
                 matTooltip="Filtering by {{ entityMap[selectedEntity] }} entity with {{ getSelectedEntityCount() }} Rules"
                 [matTooltipShowDelay]="500"></i>
              <span matTooltip="Filtering by {{ entityMap[selectedEntity] }} entity with {{ getSelectedEntityCount() }} Rules"
                    [matTooltipShowDelay]="500">({{ getSelectedEntityCount() }})</span>
            </span>
          </span>
          <app-data-rules-search
            *ngIf="rulesLoaded && dataRulesDataService.allRules.length > 0"
            [value]="searchTerm"
            [placeholder]="'Search all Rules (Ctrl+Shift+F)...'"
            [scopeFolder]="searchScopeFolder"
            (searchChange)="onSearch($event)">
          </app-data-rules-search>
          <span class="subheader-helper-text truncate"
                *ngIf="selectedSidebarFolderId === SidebarFolderId.ARCHIVE"
                [appTooltipOnTruncate]="'Rules in the Archive are inactive. Restore a Rule to make it active again'">
            Rules in the Archive are inactive. Restore a Rule to make it active again
          </span>
          <i class="material-icons-outlined notranslate subheader-info-icon"
             *ngIf="selectedSidebarFolderId === SidebarFolderId.ARCHIVE"
             matTooltip="Rules in the Archive are inactive. Restore a Rule to make it active again"
             [matTooltipShowDelay]="500"
             matTooltipPosition="below">info</i>
        </span>
        <aside *ngIf="!this.metaLoaded || !this.rulesLoaded" class="sub-info-skeleton" id="sub-info">
          <app-skeleton [style]="'new-rule-button'"></app-skeleton>
        </aside>
        <aside *ngIf="this.metaLoaded && this.rulesLoaded && selectedSidebarFolderId !== SidebarFolderId.ARCHIVE" id="sub-info">
          <button *ngIf="!viewAllSelected"
                  class="{{entitySelectorsMap[selectedEntity] | lowercase}}-entity new-rule" type="button"
                  theme="sub-info"
                  matTooltip="Create new {{entityMap[selectedEntity]}} Rule (Alt+Shift+R)"
                  [matTooltipShowDelay]="500"
                  (click)="addNewRule()" [disabled]="newRuleButtonsDisabled">
            New <span>{{ entityMap[selectedEntity] }}</span> Rule <i class="bhi-add-thin"></i>
          </button>
          <div *ngIf="viewAllSelected" class="new-entity-rule-top-right">
            <button type="button" class="new-entity-rule-action"
                    matTooltip="Create new rule (Alt+Shift+R)" [matTooltipShowDelay]="500"
                    [matTooltipDisabled]="entityMatSelectHovered"
                    (click)="addNewRuleViewAll()" [disabled]="newRuleButtonsDisabled">
              New
              <mat-select [(value)]="viewAllNewRuleEntity"
                          panelClass="entity-rule-panel"
                          class="new-rule-entity-select {{entitySelectorsMap[viewAllNewRuleEntity]}}-entity"
                          (click)="$event.stopPropagation()"
                          (mouseenter)="entityMatSelectHovered = true"
                          (mouseleave)="entityMatSelectHovered = false"
                          matTooltip="Select entity" [matTooltipShowDelay]="500">
                <mat-select-trigger>
                  <i [ngClass]="renderIcon(entitySelectorsMap[viewAllNewRuleEntity])"></i>
                  {{ entityMap[viewAllNewRuleEntity] }}
                </mat-select-trigger>
                <mat-optgroup label="Core entities">
                  <mat-option *ngFor="let entity of coreEntities | keyvalue: shiftLeadButton.bind(this)"
                              [value]="entity.key"
                              [ngClass]="entitySelectorsMap[entity.key] + '-entity'">
                    <i [ngClass]="renderIcon(entitySelectorsMap[entity.key])"></i>
                    <div class="entity-opt-block">
                      <span class="entity-opt-label">{{ entityMap[entity.key] }}</span>
                      <span class="entity-opt-key">{{ entity.key }}</span>
                    </div>
                  </mat-option>
                </mat-optgroup>
                <mat-optgroup label="File attachment entities" *ngIf="hasEntries(fileAttachmentEntities)">
                  <mat-option *ngFor="let entity of fileAttachmentEntities | keyvalue"
                              [value]="entity.key"
                              [ngClass]="entitySelectorsMap[entity.key] + '-entity'">
                    <i class="bhi-attach"></i>
                    <div class="entity-opt-block">
                      <span class="entity-opt-label">{{ entityMap[entity.key] | TransformFileAttachment }}</span>
                      <span class="entity-opt-key">{{ entity.key }}</span>
                    </div>
                  </mat-option>
                </mat-optgroup>
                <mat-optgroup label="Additional entities" *ngIf="hasEntries(additionalEntities)">
                  <mat-option *ngFor="let entity of additionalEntities | keyvalue"
                              [value]="entity.key"
                              [ngClass]="entitySelectorsMap[entity.key] + '-entity'">
                    <i [ngClass]="renderIcon(entitySelectorsMap[entity.key])"></i>
                    <div class="entity-opt-block">
                      <span class="entity-opt-label">{{ entityMap[entity.key] }}</span>
                      <span class="entity-opt-key">{{ entity.key }}</span>
                    </div>
                  </mat-option>
                </mat-optgroup>
                <mat-optgroup label="Custom object entities" *ngIf="hasEntries(customObjectEntities)">
                  <mat-option *ngFor="let entity of customObjectEntities | keyvalue"
                              [value]="entity.key"
                              [ngClass]="entitySelectorsMap[entity.key] + '-entity'">
                    <i [ngClass]="renderIcon(entitySelectorsMap[entity.key])"></i>
                    <div class="entity-opt-block">
                      <span class="entity-opt-label">{{ entityMap[entity.key] }}</span>
                      <span class="entity-opt-key">{{ entity.key }}</span>
                    </div>
                  </mat-option>
                </mat-optgroup>
              </mat-select>
              Rule <i class="bhi-add-thin"></i>
            </button>
          </div>
        </aside>
      </h2>
    </div>
    <article [ngClass]="{'archive-view': selectedSidebarFolderId === SidebarFolderId.ARCHIVE}">
      <table mat-table
             [dataSource]="dataRules"
             matSort
             [@.disabled]="suppressRowAnimations"
             class="mat-mdc-table table-full-width rules-table table-striped table-no-border-bottom row-highlight">

        <!-- Entity Column -->
        <ng-container matColumnDef="entity">
          <th mat-header-cell *matHeaderCellDef [mat-sort-header]="viewAllSelected ? 'entity' : ''"
              [disabled]="!viewAllSelected">Entity
          </th>
          <td mat-cell *matCellDef="let rule">
            <ng-container *ngIf="viewAllSelected; else specificEntity">
              <i
                [ngClass]="[renderIcon(entitySelectorsMap[rule.ruleData.source?.config?.entity]), entitySelectorsMap[rule.ruleData.source?.config?.entity] + '-entity']"
                [matTooltip]="entityMap[rule.ruleData.source?.config?.entity]" [matTooltipShowDelay]="500"></i>
            </ng-container>
            <ng-template #specificEntity>
              <i
                [ngClass]="[renderIcon(entitySelectorsMap[selectedEntity]), entitySelectorsMap[selectedEntity] + '-entity']"
                [matTooltip]="entityMap[selectedEntity]" [matTooltipShowDelay]="500"></i>
            </ng-template>
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Rule name</th>
          <td mat-cell *matCellDef="let rule">
          <a class="rule-title"
             routerLink="/datarules"
             [queryParams]="{ rule: rule.ruleData.id }"
             queryParamsHandling="merge"
             (click)="onRuleTitleInteraction($event, rule)"
             (auxclick)="onRuleTitleInteraction($event, rule)"
             (contextmenu)="onRuleTitleInteraction($event, rule)">
            {{ rule.ruleData.name || 'New rule...' }}
          </a>
            @if (rule.ruleData.action?.config?.steps?.length) {
              <ul class="actions-preview">
                <li>Actions:</li>
                @for (action of rule.ruleData.action.config.steps; track action.type + '_' + $index) {
                  <li>
                    @if (action.type === 'REPLACE_RELATIVE') {
                      REPLACE
                    } @else {
                      {{ action.type }}
                    }
                  </li>
                }
              </ul>
            }
            <div class="folder-tags-row">
              @for (folder of rule.ruleData.folders; track folder.id) {
                <span class="folder-tag-chip" @appearWidth
                      role="button" tabindex="0"
                      (click)="$event.stopPropagation(); onFolderSelected(folder.id)"
                      (keydown.enter)="onFolderSelected(folder.id)"
                      (keydown.space)="onFolderSelected(folder.id)">
                  <i class="material-icons-outlined notranslate folder-tag-icon">{{ folder.id === SidebarFolderId.ARCHIVE ? 'unarchive' : 'folder' }}</i>
                  <span class="folder-tag-label truncate" [matTooltip]="'Open ' + folder.name + ' folder'"
                        [matTooltipShowDelay]="500">{{ folder.name }}</span>
                  <i class="material-icons-outlined notranslate folder-tag-remove"
                     role="button" tabindex="0"
                     [matTooltip]="'Remove from ' + folder.name + ' folder'" [matTooltipShowDelay]="500"
                     (click)="removeFromFolder($event, rule, folder.id)"
                     (keydown.enter)="removeFromFolder($event, rule, folder.id)"
                     (keydown.space)="$event.preventDefault(); removeFromFolder($event, rule, folder.id)">close</i>
                </span>
              }
              <i class="material-icons-outlined notranslate folder-tag-add-btn"
                 role="button" tabindex="0"
                 (click)="openAddToFolderPopup($event, rule)"
                 (keydown.enter)="openAddToFolderPopup($event, rule)"
                 (keydown.space)="$event.preventDefault(); openAddToFolderPopup($event, rule)"
                 matTooltip="Add to folder" [matTooltipShowDelay]="500">create_new_folder</i>
            </div>
          </td>
        </ng-container>

        <!-- Last Run Column -->
        <ng-container matColumnDef="lastRun">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last run</th>
          <td mat-cell *matCellDef="let rule">
            <ng-container *ngIf="getRuleStat(rule.ruleData.id) as stat; else noLastRun">
              <span matTooltip="Your local time" matTooltipPosition="above" [matTooltipShowDelay]="500">{{ stat.startTime | date:'medium' }}</span>
            </ng-container>
            <ng-template #noLastRun><span class="disabled">-</span></ng-template>
          </td>
        </ng-container>

        <!-- Next Run Column -->
        <ng-container matColumnDef="nextRun">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Next run</th>
          <td mat-cell *matCellDef="let rule">
            <ng-container *ngIf="!utilsService.compareInternalDataRuleIds(rule.ruleData.id, 0)">
              <ng-container *ngIf="isNextRunUnavailable(rule.ruleData.id); else nextRunDate">
                <span class="disabled">-</span>
              </ng-container>
              <ng-template #nextRunDate><span matTooltip="Your local time" matTooltipPosition="above" [matTooltipShowDelay]="500">{{ getNextRunTimestamp(rule.ruleData.id) | date:'medium' }}</span></ng-template>
            </ng-container>
          </td>
        </ng-container>

        <!-- Total Runs Column -->
        <ng-container matColumnDef="totalRuns">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Total runs</th>
          <td mat-cell *matCellDef="let rule">
            <ng-container *ngIf="getRuleStat(rule.ruleData.id) as stat; else noRuns">{{ stat.timesRun }}</ng-container>
            <ng-template #noRuns><span class="disabled">-</span></ng-template>
          </td>
        </ng-container>

        <!-- Schedule Column -->
        <ng-container matColumnDef="schedule">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span class="schedule-header-text">Schedule</span>
            <i class="material-icons notranslate schedule-header-icon"
               matTooltip="Schedule" matTooltipPosition="above" [matTooltipShowDelay]="500">alarm</i>
          </th>
          <td mat-cell *matCellDef="let rule">
            <ng-container *ngIf="schedulingEnabled && !utilsService.compareInternalDataRuleIds(rule.ruleData.id, 0)">
              <ng-container
                *ngIf="isRuleInAChain(rule.ruleData.id) ? isRuleFirstInAChain(rule.ruleData.id) : true; else schedulingDisabled">
                <ng-container *ngIf="!isRuleEnrichBlocked(rule); else enrichCreditBlockedSchedule">
                  <div class="schedule-container" #scheduleAnchorEl
                       [style.anchor-name]="'--schedule-' + rule.ruleData.id">
                    <span *ngIf="ruleSchedule(rule.ruleData.id) && !ruleSchedule(rule.ruleData.id)?.isExpired"
                          class="scheduled"
                          (click)="openScheduled(dataRules.data.indexOf(rule)); $event.stopPropagation()">
                      <i class="material-icons notranslate schedule-icon green"
                         matTooltip="Runs every {{ ruleSchedule(rule.ruleData.id)?.ruleExpression | lowercase }}"
                         matTooltipPosition="above" [matTooltipShowDelay]="500">alarm_on</i>
                      <span *ngIf="!rule.viewState.scheduleSaving" class="schedule-expression"><span
                        class="grey">EVERY </span>{{ ruleSchedule(rule.ruleData.id)?.ruleExpression }}</span>
                    </span>
                    <span
                      *ngIf="(!ruleSchedule(rule.ruleData.id) || ruleSchedule(rule.ruleData.id)?.isExpired) && !rule.viewState.scheduleSaving && !rule.ruleData.isArchived"
                      class="scheduled" (click)="openScheduled(dataRules.data.indexOf(rule)); $event.stopPropagation()">
                      <i class="material-icons notranslate schedule-icon"
                         matTooltip="Schedule when to automatically run {{rule.ruleData.name}}"
                         matTooltipShowDelay="500" matTooltipPosition="above">alarm</i>
                    </span>
                    <span *ngIf="rule.viewState.scheduleSaving" class="saving spinner-border spinner-border-sm"
                          [matTooltip]="deletingSchedule ? 'Removing schedule' : 'Saving schedule'"
                          [matTooltipHideDelay]="500"></span>
                  </div>
                  <app-rule-schedule-folders *ngIf="rule.viewState.scheduleOpen"
                                             [dataRule]="rule"
                                             [anchorName]="'--schedule-' + rule.ruleData.id"
                                             [anchorEl]="scheduleAnchorEl"
                                             (scheduleSaving)="saveSchedule($event, dataRules.data.indexOf(rule))"
                                             (scheduleDeleting)="deleteSchedule(dataRules.data.indexOf(rule))"
                                             [isRuleFirstInAChain]="isRuleFirstInAChain.bind(this)">
                  </app-rule-schedule-folders>
                </ng-container>
                <ng-template #enrichCreditBlockedSchedule>
                  <span (click)="$event.stopPropagation()">
                    <i [attr.aria-disabled]="'true'" class="material-icons notranslate credit-blocked-icon"
                       [matTooltip]="enrichCreditBlockedTooltip"
                       [matTooltipShowDelay]="500"
                       matTooltipPosition="above">alarm_off</i>
                  </span>
                </ng-template>
              </ng-container>
              <ng-template #schedulingDisabled>
                <span>
                <!-- TODO: Refactor this so just looking at conditional disabled attribute rather than ng-container else? -->
                  <i disabled="true" class="material-icons notranslate"
                     matTooltip="Rule in Chained Rule Group">alarm_off</i>
                </span>
              </ng-template>
            </ng-container>
          </td>
        </ng-container>

        <!-- Row Actions Column -->
        <ng-container matColumnDef="rowActions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let rule">
            <div class="action-icons inline">
              <span class="chained icon-container" *ngIf="isRuleInAChain(rule.ruleData.id)"
                    [appCustomOverlayTriggerFor]="ruleInChainInfo"
                    [shouldClose]="shouldRuleChainInfoClose">
                <span class="action-icon-text" matTooltip="Rule chained">CHAINED</span>
                <i [ngClass]="{'material-icons notranslate chain-group-icon': true}" tabindex="0">playlist_play</i>
                <app-rule-in-chain-screen
                  #ruleInChainInfo
                  [ruleId]="rule.ruleData.id"
                  [overlayPositioningConfig]="ruleInChainOverlayPositioningConfig"
                  [navigateToDataRules]="navigateToDataRules.bind(this)"
                ></app-rule-in-chain-screen>
              </span>
              <span *ngIf="selectedSidebarFolderId === SidebarFolderId.ARCHIVE"
                    class="icon-container icon-vertical-divide"
                    matTooltip="Restore {{rule.ruleData.name}} from Archive"
                    matTooltipPosition="above" [matTooltipShowDelay]="500">
                <i class="material-icons-outlined notranslate unarchive-icon"
                   (click)="removeFromFolder($event, rule, SidebarFolderId.ARCHIVE)">unarchive</i>
              </span>
              <span class="icon-container"
                    [matTooltip]="rule.viewState.dirty ? 'Rule needs saving before duplicating' : 'Duplicate ' + rule.ruleData.name"
                    matTooltipPosition="above" [matTooltipShowDelay]="500">
                <i class="material-icons copy-icon notranslate"
                   [ngClass]="{'disabled': rule.viewState.dirty}"
                   (click)="duplicateRule(rule); $event.stopPropagation()">content_copy</i>
              </span>
              <i matTooltip="Delete {{rule.ruleData.name}}"
                 matTooltipPosition="above" [matTooltipShowDelay]="500"
                 class="material-icons delete-icon notranslate"
                 (click)="deleteRule(dataRules.data.indexOf(rule)); $event.stopPropagation()">delete_outline</i>
              <span class="icon-container"
                    (click)="$event.stopPropagation()"
                    [class.icon-container--blocked]="isRuleEnrichBlocked(rule)"
                    [matTooltip]="rule.viewState.dirty ? 'Rule needs saving before running' : rule.ruleData.isArchived ? 'Archived rules cannot be run' : isRuleEnrichBlocked(rule) ? enrichCreditBlockedTooltip : 'View results for ' + rule.ruleData.name"
                    matTooltipPosition="above" [matTooltipShowDelay]="500">
                <i class="material-icons notranslate"
                   (click)="viewExamplesForRule(dataRules.data.indexOf(rule), rule.ruleData.id); $event.stopPropagation()"
                   [ngClass]="{'disabled': rule.viewState.dirty || rule.ruleData.isArchived || isRuleEnrichBlocked(rule)}">play_arrow</i>
              </span>
            </div>
          </td>
        </ng-container>

        <!-- Header Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <!-- Main Data Rows -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            class="mat-standard-row"
            [class.schedule-open]="row.viewState.scheduleOpen"
            (click)="openRuleModal(row)"
            @transitionNewRowInOut>
        </tr>
      </table>

      @if (remainingRowCount > 0) {
        <div class="pending-rows-region">
          <div #rulesScrollSentinel class="scroll-sentinel-marker" aria-hidden="true"></div>
          <div class="loading-more-rows-indicator" [class.active]="isLoadingMoreRows" aria-live="polite">Loading more Rules...</div>
          <app-skeleton class="leading-skeleton" [style]="'bigger-row-table'" [count]="leadingSkeletonCount"></app-skeleton>
          @if (spacerHeightPx > 0) {
            <div class="rows-pending-spacer" [style.height.px]="spacerHeightPx" aria-hidden="true"></div>
          }
          @if (trailingSkeletonCount > 0) {
            <app-skeleton class="trailing-skeleton" [style]="'bigger-row-table'" [count]="trailingSkeletonCount"></app-skeleton>
          }
        </div>
      }
      <mat-paginator [pageSize]="initialRenderBatchSize" [hidden]="true" aria-hidden="true"></mat-paginator>
      <div *ngIf="this.metaLoaded && this.rulesLoaded && dataRulesDataService.allRules.length > 0
                  && !searchTerm && dataRules.filteredData.length === 0 && selectedSidebarFolderId === SidebarFolderId.ALL_RULES"
           class="no-results">
        No rules found for this entity, please create one below
      </div>
      <div *ngIf="this.metaLoaded && this.rulesLoaded && dataRulesDataService.allRules.length > 0
                  && searchTerm && dataRules.filteredData.length === 0"
           class="no-results">
        No Rules matching <em class="grey">{{ searchTerm }}</em>
        <span class="search-no-results-scope">
          In <button class="folder-tag-chip"
                    (click)="onFolderSelected(selectedFolder.id)"
                    [attr.aria-label]="'Go to ' + selectedFolder.name"
                    [matTooltip]="'View All rules in ' + selectedFolder.name"
                    matTooltipPosition="above"
                    [matTooltipShowDelay]="500">
            <i class="material-icons-outlined notranslate folder-tag-icon">folder_open</i>
            <span class="folder-tag-label">{{ selectedFolder.name }}</span>
          </button>
          <ng-container *ngIf="!viewAllSelected"> and <span class="entity-tag-chip" [ngClass]="entitySelectorsMap[selectedEntity]"><i [ngClass]="renderIcon(entitySelectorsMap[selectedEntity])"></i>{{ entityMap[selectedEntity] }}</span> entity</ng-container>
        </span>
        <span class="no-results-chip-row search-scope-suggestion" *ngIf="selectedSidebarFolderId !== SidebarFolderId.ALL_RULES || !viewAllSelected">
          Would you like to search all entities in
          <button class="folder-tag-chip"
                  (click)="searchInAllRules()"
                  aria-label="Search All Rules"
                  matTooltip="Search '{{ searchTerm }}' across All Rules"
                  matTooltipPosition="above"
                  [matTooltipShowDelay]="500">
            <i class="material-icons-outlined notranslate folder-tag-icon">search</i>
            <span class="folder-tag-label">All Rules</span>
          </button>
          instead?
        </span>
      </div>
      <div *ngIf="this.metaLoaded && this.rulesLoaded && selectedSidebarFolderId === SidebarFolderId.ALL_RULES && selectedFolder.count === 0"
           class="no-results">
        No Rules have been created yet<br>
        Use the New Rule button below to get started
      </div>
      <div *ngIf="this.metaLoaded && this.rulesLoaded && selectedSidebarFolderId !== SidebarFolderId.ALL_RULES && selectedFolder.count === 0 && !searchTerm"
           class="no-results">
        <ng-container *ngIf="selectedSidebarFolderId === SidebarFolderId.ARCHIVE; else defaultEmptyFolder">
          No Rules are currently archived<br>
          <span class="no-results-chip-row">Rules are all available under
            <button class="folder-tag-chip"
                    (click)="onFolderSelected(SidebarFolderId.ALL_RULES)"
                    matTooltip="Go to All Rules"
                    matTooltipPosition="above"
                    [matTooltipShowDelay]="500">
              <i class="material-icons-outlined notranslate folder-tag-icon">folder_open</i>
              <span class="folder-tag-label">All Rules</span>
            </button>
          </span>
        </ng-container>
        <ng-template #defaultEmptyFolder>
          No Rules have been added to this Folder yet
          <span class="no-results-chip-row no-results-chip-row--standalone" *ngIf="selectedSidebarFolderId !== 'all' && selectedFolder?.count === 0">
            <button class="folder-tag-chip"
                    (click)="openFolderPopupFromEmptyState($event)"
                    matTooltip="Add Rules to this Folder"
                    matTooltipPosition="above"
                    [matTooltipShowDelay]="500">
              <i class="material-icons-outlined notranslate folder-tag-icon">add</i>
              <span class="folder-tag-label">Select Rules to add</span>
            </button>
          </span>
        </ng-template>
      </div>
      <div *ngIf="this.metaLoaded && this.rulesLoaded && selectedSidebarFolderId !== SidebarFolderId.ALL_RULES && selectedFolder.count > 0 && !viewAllSelected && dataRules.filteredData.length === 0 && !searchTerm"
           class="no-results">
        This Folder has no <span class="entity-tag-chip" [ngClass]="entitySelectorsMap[selectedEntity]"><i [ngClass]="renderIcon(entitySelectorsMap[selectedEntity])"></i>{{ entityMap[selectedEntity] }}</span> Rules<br>
        <span class="no-results-chip-row">Filter by
          <button class="folder-tag-chip"
                  (click)="onViewAllClicked()"
                  matTooltip="View Rules for all entities in this Folder"
                  matTooltipPosition="above"
                  [matTooltipShowDelay]="500">
            <i class="material-icons-outlined notranslate folder-tag-icon">checklist</i>
            <span class="folder-tag-label">All entities</span>
          </button>?
        </span>
      </div>
      <app-skeleton *ngIf="!this.metaLoaded || !this.rulesLoaded" [style]="'bigger-row-table'"
                    [count]="3"></app-skeleton>
      <section *ngIf="this.metaLoaded && this.rulesLoaded && selectedSidebarFolderId !== SidebarFolderId.ARCHIVE" class="footer-btns stretch-btns">
        <button *ngIf="!viewAllSelected"
                id="bottom-create-rule-button" theme="nav" class="{{entitySelectorsMap[selectedEntity]}}-entity"
                matTooltip="Create new {{entityMap[selectedEntity]}} Rule (Alt+Shift+R)"
                [matTooltipShowDelay]="500"
                (click)="addNewRule()" [disabled]="newRuleButtonsDisabled" appRipple>
        <span>New <span class="entity-text">{{ entityMap[selectedEntity] }}</span> Rule <i
          class="bhi-add-thin"></i></span>
        </button>
        <ng-container *ngIf="viewAllSelected">
          <button type="button" theme="nav" class="new-entity-rule-action view-all-entities-button"
                  [ngClass]="entitySelectorsMap[viewAllNewRuleEntity] ? entitySelectorsMap[viewAllNewRuleEntity] + '-entity' : ''"
                  matTooltip="Create new rule (Alt+Shift+R)" [matTooltipShowDelay]="500"
                  [matTooltipDisabled]="entityMatSelectHovered"
                  (click)="addNewRuleViewAll()"
                  [disabled]="newRuleButtonsDisabled">
            New
            <mat-select [(value)]="viewAllNewRuleEntity"
                        panelClass="entity-rule-panel"
                        class="new-rule-entity-select {{entitySelectorsMap[viewAllNewRuleEntity]}}-entity"
                        matTooltip="Select entity" [matTooltipShowDelay]="500"
                        (click)="$event.stopPropagation()"
                        (mouseenter)="entityMatSelectHovered = true"
                        (mouseleave)="entityMatSelectHovered = false">
              <mat-select-trigger>
                <i [ngClass]="renderIcon(entitySelectorsMap[viewAllNewRuleEntity])"></i>
                {{ entityMap[viewAllNewRuleEntity] }}
              </mat-select-trigger>
              <!-- TODO: Make this a reusable component rather than repeating at the top -->
              <mat-optgroup label="Core entities">
                <mat-option *ngFor="let entity of coreEntities | keyvalue: shiftLeadButton.bind(this)"
                            [value]="entity.key"
                            [ngClass]="entitySelectorsMap[entity.key] + '-entity'">
                  <i [ngClass]="renderIcon(entitySelectorsMap[entity.key])"></i>
                  <div class="entity-opt-block">
                    <span class="entity-opt-label">{{ entityMap[entity.key] }}</span>
                    <span class="entity-opt-key">{{ entity.key }}</span>
                  </div>
                </mat-option>
              </mat-optgroup>
              <mat-optgroup label="File attachment entities" *ngIf="hasEntries(fileAttachmentEntities)">
                <mat-option *ngFor="let entity of fileAttachmentEntities | keyvalue"
                            [value]="entity.key"
                            [ngClass]="entitySelectorsMap[entity.key] + '-entity'">
                  <i class="bhi-attach"></i>
                  <div class="entity-opt-block">
                    <span class="entity-opt-label">{{ entityMap[entity.key] | TransformFileAttachment }}</span>
                    <span class="entity-opt-key">{{ entity.key }}</span>
                  </div>
                </mat-option>
              </mat-optgroup>
              <mat-optgroup label="Additional entities" *ngIf="hasEntries(additionalEntities)">
                <mat-option *ngFor="let entity of additionalEntities | keyvalue"
                            [value]="entity.key"
                            [ngClass]="entitySelectorsMap[entity.key] + '-entity'">
                  <i [ngClass]="renderIcon(entitySelectorsMap[entity.key])"></i>
                  <div class="entity-opt-block">
                    <span class="entity-opt-label">{{ entityMap[entity.key] }}</span>
                    <span class="entity-opt-key">{{ entity.key }}</span>
                  </div>
                </mat-option>
              </mat-optgroup>
              <mat-optgroup label="Custom object entities" *ngIf="hasEntries(customObjectEntities)">
                <mat-option *ngFor="let entity of customObjectEntities | keyvalue"
                            [value]="entity.key"
                            [ngClass]="entitySelectorsMap[entity.key] + '-entity'">
                  <i [ngClass]="renderIcon(entitySelectorsMap[entity.key])"></i>
                  <div class="entity-opt-block">
                    <span class="entity-opt-label">{{ entityMap[entity.key] }}</span>
                    <span class="entity-opt-key">{{ entity.key }}</span>
                  </div>
                </mat-option>
              </mat-optgroup>
            </mat-select>
            Rule <i class="bhi-add-thin"></i>
          </button>
        </ng-container>
      </section>
    </article>
  </div>
</div>

<app-loading-snackbar></app-loading-snackbar>

<app-folder-popup *ngIf="sidebarCreateFolderPopupOpen"
                  [mode]="'create-folder'"
                  [allFolders]="sidebarUserFolders"
                  [reservedFolderNames]="reservedFolderNames"
                  (folderCreated)="onFolderCreated($event)"
                  (closed)="closeSidebarCreateFolderPopup()">
</app-folder-popup>

<app-folder-popup *ngIf="activeRuleForFolderPopup"
                  [mode]="'manage-folders'"
                  [ruleFolders]="activeRuleForFolderPopup?.ruleData?.folders ?? []"
                  [allFolders]="sidebarUserFolders"
                  [reservedFolderNames]="reservedFolderNames"
                  (folderAdded)="onFolderAddedToRule($event)"
                  (folderRemoved)="onFolderRemovedFromRule($event)"
                  (folderCreated)="onFolderCreated($event)"
                  (archiveRequested)="onArchiveRequestedFromPopup()"
                  (closed)="closeAddToFolderPopup()">
</app-folder-popup>

<app-folder-popup *ngIf="sidebarPopupData"
                  [mode]="'manage-rules'"
                  [folder]="sidebarPopupData.folder"
                  [folderRules]="sidebarPopupData.folderRules"
                  [allRules]="allRulesList"
                  [allFolders]="sidebarUserFolders"
                  [reservedFolderNames]="reservedFolderNames"
                  (renameRequested)="sidebarRef.onFolderRenamed($event)"
                  (ruleAdded)="sidebarRef.onRuleAdded($event)"
                  (ruleRemoved)="sidebarRef.onRuleRemoved($event)"
                  (deleteRequested)="sidebarRef.onDeleteRequested()"
                  (closed)="sidebarRef.closePopup()">
</app-folder-popup>
